import * as React from 'react';

import elements from 'components/elements';
import { EVENTS } from 'components/Tables/fsm';
import { Cell } from 'components/Tables/Cells/LiteralCell/StyledComponents';

class LiteralCell extends React.Component {
  state = {
    value: this.constructor.getValue(this.props),
  };

  static getValue({ data: { cellSet, initValue }, value }) {
    if (value !== cellSet.value) return value || '';
    if (cellSet.value) return cellSet.value;
    return initValue || '';
  }

  get isInitial() {
    if (this.state.value === this.props.data.initValue) return true;
    return false;
  }

  handleUpdate = (value) => {
    const { onChange, data } = this.props;
    if (value !== data.cellSet.value) {
      onChange(data._cell, data.cellSet.set('value', value.length ? value : null));
    }
  };

  handleChange = (event) => {
    this.setState({
      value: event.target.value,
    });
  };

  handleBlur = () => {
    this.handleUpdate(this.state.value);
    this.props.onBlur();
  };

  handleKyeDown = (e) => {
    if (e.keyCode === 9) e.preventDefault();
    if (e.keyCode === 13 || e.keyCode === 9) {
      // ENTER  // TAB
      this.handleUpdate(this.state.value);
      this.props.eventCollector(EVENTS.onEnter);
    }
    if (e.keyCode === 27) {
      // Esc
      this.props.eventCollector(EVENTS.onEsc);
    }
  };

  render() {
    const { data, maxLength } = this.props;
    return (
      <Cell
        {...(this.isInitial ? { sx: { color: 'hsl(210, 14%, 70%)' } } : {})}
        id={this.props.data._cell}
        name={this.props.data.name}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
        value={this.state.value}
        ref={this.props.getRefs}
        onKeyDown={this.handleKyeDown}
        maxLength={maxLength}
        data-element={elements.je.literal.field}
        data-element-id={`${data._cell}-${data.type}`}
      />
    );
  }
}

export default LiteralCell;
